<template>
  <div class="page-index template-index">

    <el-table
        ref="table"
        :data="list"
        stripe
        size="mini"
        empty-text="暂无数据"
        row-class-name="table-row-cursor"
        header-row-class-name="header-row"
        :height="tableHeight"
        :maxHeight="tableHeight"
        style="width: 100%;">
      <el-table-column
          header-align="center"
          align="center"
          type="index"
          :index="indexMethod"
          width="50"
          label="#">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="name"
          label="标签模板名称">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="width"
          label="长度">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="height"
          label="宽度">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="80">
        <template slot-scope="scope">
          <el-tooltip content="预览" placement="top">
            <el-button size="mini" @click.stop="openModel(scope.row)" title="预览">
              <i class="icon el-icon-detail"></i>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
        :current-page.sync="pageIndex"
        @current-change="pageChange"
        layout="->, total, prev, pager, next"
        :page-size="pageSize"
        :total="total"
        class="pagination">
    </el-pagination>

    <el-dialog
        title="模板预览"
        :visible.sync="dialogVisible"
        :width="currentRow.width * 4 + 40 + 'px'">
      <div style="display: flex;justify-content: center;">
        <iframe :src="currentRow.url" frameborder="0" scrolling="no" :style="{width: currentRow.width + 'mm', height: currentRow.height + 'mm'}"></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import { tableMixin } from '../../mixins/table'
  import { mapGetters } from 'vuex'
  import { apiLabelModuleList } from '../../api/label'

  export default {
    mixins: [tableMixin],
    name: 'template-index',
    data() {
      return {
        dialogVisible: false,
        list: [],
        total: 0,
        pageSize: 1,
        currentRow: {}
      }
    },
    computed: {
      ...mapGetters([
        'userInfo',
        'roles',
        'currentRoles'
      ])
    },
    created() {
    },
    activated() {
      this._getList()
    },
    methods: {
      indexMethod(index) {
        return (this.pageIndex - 1) * 20 + index + 1
      },
      openModel(row) {
        this.dialogVisible = true
        this.currentRow = row
      },
      // 翻页
      pageChange(pageIndex) {
        this.pageIndex = pageIndex
        this._getList(pageIndex)
      },
      // 获取列表
      _getList(pageIndex = 1) {
        apiLabelModuleList(pageIndex).then(data => {
          this.list = data.data.data
          this.total = data.data.total
        })
      }
    }
  }
</script>

<style lang="stylus">
  .page-index.template-index
    .toolbar-box
      display flex
      margin 10px 0
      .btn-left
        background #A5CE1C
        color #fff
        margin-right 20px
    .main-box
      display flex
      .seting-box, .preview-box
        background-color #fff
      .seting-box
        flex 1
        padding 20px
        margin-right 20px
      .preview-box
        width 100%
        .flex
          display flex
        .flex-1
          flex 1
  .el-col
      .el-form-item
        margin-bottom 0
</style>
